e4.productlist = {
    jProductLists: jQuery( '.js-e-productlist' ),
    init: function () {
        if ( e4.productlist.jProductLists.length > 0 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {

                e4.handlebars.registerHelpers( 'compare' );
                e4.productlist.handlebars.helpers();

                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-productlist-filters #js-e-handlebars-tmpl-productlist-products #js-e-handlebars-tmpl-productlist-sort #js-e-handlebars-tmpl-productlist-paging' );
                e4.productlist.event = e4.util.registerEvents( 'build builded', 'productlist' );
                
                e4.productlist.jProductLists.each(function(index, element) {
                    var jProductList = e4.productlist.jProductLists.eq(index);
                    var strTmplKey = jProductList.data("templatekey");
                    e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-productlist-filters-' + strTmplKey);
                    e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-productlist-products-' + strTmplKey);
                    e4.productlist.bindEvents(jProductList);
                    e4.productlist.history.init(jProductList);
                    e4.productlist.filters.init(jProductList); 
                    e4.productlist.modal.init(jProductList);
                });
            } );
        }
    },
    bindEvents: function ( jProductList ) {
        jProductList.on( 'click', '.js-e-productlist-set-pagesize', function ( event ) {
            event.preventDefault();
            var intPagesize = jQuery( this ).data( 'page-size' );
            e4.productlist.setPagesize( intPagesize, jProductList );
        } );
        jProductList.on( 'click', '.js-e-productlist-set-pagenum', function ( event ) {
            event.preventDefault();
            e4.productlist.setPagenum( this, jProductList );
        } );
        jProductList.on( 'change', '.js-e-productlist-sort-select', function () {
            e4.productlist.setSort( this, jProductList );
        } );
        jProductList.on( 'click', '.js-e-products-item a', function ( event ) {
            var jProductItem = jQuery( event.target.closest( '.e-products-item-container' ) );
            e4.productlist.datalayer.selectItem( jProductItem.data() );
            e4.productlist.history.pushState( jProductList );
        } );
    },
    datalayer: {
        selectItem: function ( data ) {
            e4.gtm.pushDataLayer( { ecommerce: null } ); 
            e4.gtm.pushDataLayer( {
                event: "select_item",
                ecommerce: {
                    items: [
                        {
                            item_id: data.id,
                            item_name: data.name,
                            item_category: data.category,
                            item_list_name: data.listname
                        }
                    ]
                }
            } );
        } 
    },
    handlebars: {
        helpers: function () {
            Handlebars.registerHelper( 'striptags', function ( txt ) {
                return txt;
            } ); 
        }
    },
    filters: {
        init: function ( jProductList ) {
            e4.productlist.filters.bindEvents( jProductList ); 
            e4.productlist.filters.collapse.init(jProductList);
            e4.productlist.filters.range.init(jProductList);
            e4.productlist.filters.search.init(jProductList); 
        },
        bindEvents: function (jProductList) {
            jProductList.on( 'change', '.js-e-productlist-filter', function () {
                e4.productlist.filters.applyFilters( this, jProductList ); 
            } );
            jProductList.on( 'click', '.js-e-productlist-filters-remove', function ( event ) {
                event.preventDefault();
                e4.productlist.filters.removeFilter( this, jProductList );
            } );
            jQuery( document ).on( 'click', '.js-e-productlist-filters-clear-all', function ( event ) {
                event.preventDefault();
                e4.productlist.filters.resetAll(jProductList);
            } );
            jProductList.on( 'change', '.js-e-productlist-filters-option-reset-group', function ( event ) {
                event.preventDefault();
                if ( jQuery( this ).is( ':checked' ) === true ) {
                    e4.productlist.filters.resetGroup( this, jProductList );
                }
                else {
                    jQuery( this ).prop( 'checked', true );
                }
            } );
            jProductList.on( 'click', '.js-e-productlist-filters-options-collapse-peek-toggle', function ( event ) {
                event.preventDefault();
                e4.productlist.filters.collapse.peek.toggle( this );
            } );
            jProductList.on( 'keydown', '.js-e-productlist-form', function ( event ) {
                if ( event.keyCode === 13 ) {
                    event.preventDefault();
                    e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList ); //Brug ProductList fra namespace.
                }
            } );
            
            jQuery( document ).on( 'click', '.js-e-productlist-filters-range-clear', function ( event ) {
                event.preventDefault();
                jQuery( '.js-e-productlist-filters-range-group' ).find( '.js-e-productlist-filters-range' ).val( '' );
                e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList ); //Brug ProductList fra namespace.
            } );
        },
        refresh: function (jProductList) {
            e4.productlist.filters.collapse.init(jProductList);
            //            e4.productlist.filters.range.validate();
        },
        applyFilters: function ( domElm, jProductList ) {
            var jThis = jQuery( domElm );
            jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', false );
            if ( jThis.is( ':checked' ) === false ) {
                var checkedLength = jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).filter( ':checked' ).length;
                if ( checkedLength === 0 ) {
                    jThis.closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filters-option-reset-group' ).prop( 'checked', true );
                }
            }
            jQuery( 'input[name="PageNum"]' ).val( 1 );
            e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
        },
        removeFilter: function ( domElm, jProductList ) {
            var strValue = jQuery( domElm ).data( 'value' );
            jProductList.find( '.js-e-productlist-filter[value="' + strValue + '"]' ).prop( 'checked', false );
            e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
        },
        resetGroup: function ( domElm, jProductList ) {
            jQuery( domElm ).closest( '.js-e-productlist-filters-group' ).find( '.js-e-productlist-filter' ).prop( 'checked', false );
            e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
        },
        resetAll: function (jProductList) {
            jQuery( 'input[name="PageNum"]' ).val( 1 );
            jProductList.find( '.js-e-productlist-filter' ).prop( 'checked', false );
            jProductList.find( '.js-e-search-input' ).val( '' );
            jProductList.find( '.js-e-productlist-filters-range' ).val( '' );
            e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), 0, jProductList );
        },
        collapse: {
            init: function (jProductList) {
                jProductList.find( '.js-e-productlist-filters-group-options' ).each( function () {
                    var jThis     = jQuery( this ), 
                        jPeekable = jThis.find( '.js-e-productlist-filters-options-collapse-peek' );
                    if ( jThis.is( '.collapse' ) === true ) {
                        jThis.addClass( 'show' );
                    }
                    if ( jPeekable.length === 1 ) {
                        e4.productlist.filters.collapse.peek.setHeight( jPeekable );
                    }
                    if ( jThis.is( '.is-expanded' ) === false ) {
                        jThis.removeClass( 'show' );
                    }
                } );
            },
            peek: {
                setHeight: function ( jPeekable ) {
                    var jFilterOptions        = jPeekable.find( '.js-e-productlist-filters-option' ),
                        intPeekOptionCount    = parseInt( jQuery( '.js-e-visible-options-count' ).val() ) + 1.5,
                        intHeightPeek         = Math.ceil( jFilterOptions.first().outerHeight() ) * intPeekOptionCount,
                        intHeightInitial      = jPeekable.get( 0 ).scrollHeight,
                        intHeightToggleButton = jPeekable.find( '.js-e-productlist-filters-options-collapse-peek-toggle' ).outerHeight();
                    if ( jFilterOptions.filter( '.is-selected' ).length === 0 && jFilterOptions.length > intPeekOptionCount && intHeightInitial > intHeightPeek * e4.settings.collapse.peekSizeMin ) {
                        jPeekable.data( {
                            'height-peek': intHeightPeek + intHeightToggleButton,
                            'height-initial': intHeightInitial + intHeightToggleButton
                        } );
                        jPeekable.addClass( 'is-peeking' );
                        jPeekable.css( 'max-height', jPeekable.data( 'height-peek' ) );
                    }
                    else {
                        jPeekable.removeClass( 'e-productlist-filters-options-collapse-peek is-peeking' );
                        jPeekable.find( '.js-e-productlist-filters-options-collapse-peek-toggle' ).remove();
                    }
                },
                toggle: function ( domElm ) {
                    var jPeekable = jQuery( domElm ).closest( '.js-e-productlist-filters-options-collapse-peek' );
                    if ( jPeekable.is( '.is-peeking' ) === true ) {
                        jPeekable.removeClass( 'is-peeking' );
                        jPeekable.css( 'max-height', jPeekable.data( 'height-initial' ) );
                    }
                    else {
                        jPeekable.addClass( 'is-peeking' );
                        jPeekable.css( 'max-height', jPeekable.data( 'height-peek' ) );
                    }
                }
            }
        },
        range: {
            init: function (jProductList) {
                e4.util.require.js( e4.settings.require.jQueryValidate, function () {
                    jQuery.validator.addMethod( 'rangeValid', function ( value, element, compareInput ) {
                        return parseInt( value ) > parseInt( jQuery( compareInput ).val() );
                    } );
                    e4.productlist.filters.range.bindEvents(jProductList);
                } );
            },
            bindEvents: function (jProductList) {
                jProductList.on( 'click', '.js-e-productlist-filters-apply-range', function () {
                    if ( jProductList.find( '.js-e-productlist-form' ).valid() === true ) {
                        jQuery( 'input[name="PageNum"]' ).val( 1 );
                        e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
                    }
                } );
            },
            validate: function (jProductList) {
                jProductList.find( '.js-e-productlist-form' ).validate( {
                    rules: {
                        PriceRangeMin: {
                            number: true
                        },
                        PriceRangeMax: {
                            number: true,
                            rangeValid: '.js-e-productlist-filters-range-min'
                        }
                    }
                } );
            }
        },
        search: {
            init: function (jProductList) {
                e4.productlist.filters.search.bindEvents(jProductList);
            },
            bindEvents: function (jProductList) {
                jProductList.on( 'click', '.js-e-productlist-filters-search-submit', function () {
                    e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
                } );
                jProductList.on( 'click', '.js-e-search-clear', function () {
                    e4.search.clearInput( this );
                    e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
                } );
                jProductList.on( 'keyup input', '.js-e-search-input', function ( event ) {
                    e4.search.toggleInputGroupState( this, event );
                } );
                jProductList.on( 'click', '.js-e-productlist-filters-search-clear', function ( event ) {
                    event.preventDefault();
                    jProductList.find( '.js-e-search-input' ).val( '' );
                    e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
                } );
            }
        }
    },
    modal: {
        init: function (jProductList) {
            e4.productlist.modal.bindEvents(jProductList);
        },
        bindEvents: function (jProductList) {
            jProductList.find( '.js-e-productlist-filters-modal' ).on( 'show.bs.modal', function () {
                e4.util.hash.set( 'isModalFilter', 'true' );
            } ).on( 'hide.bs.modal', function () {
                jProductList.find( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
                e4.util.hash.remove( 'isModalFilter' );
                setTimeout( function () {
                    jProductList.find( '.js-e-products-loading-overlay' ).removeClass( 'is-loading' );
                }, e4.settings.ecom.filters.delay );
            } );
        }
    },
    setPagesize: function ( intPagesize, jProductList ) {

        jProductList.find( 'input[name="PageSize"]' ).val( intPagesize );
        jProductList.find( 'input[name="PageNum"]' ).val( 1 );
        e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
        
    },
    setPagenum: function ( domElm, jProductList ) {
        var intPagenum = jQuery( domElm ).data( 'page-num' );
        jProductList.find( 'input[name="PageNum"]' ).val( intPagenum );
        e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
        
    },
    setSort: function ( domElm, jProductList ) {
        var arrSelectSortValue = jQuery( domElm ).val().split( ' ' );
        if ( arrSelectSortValue.length === 2 ) {
            jProductList.find( 'input[name="Sort"]' ).val( arrSelectSortValue[ 0 ] + ' ' + arrSelectSortValue[ 1 ] );
            jProductList.find( 'input[name="SortBy"]' ).val( arrSelectSortValue[ 0 ] );
            jProductList.find( 'input[name="SortOrder"]' ).val( arrSelectSortValue[ 1 ] );
        }
        else {
            jProductList.find( 'input[name="SortBy"], input[name="SortOrder"]' ).val( '' );
        }
        e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), jProductList.offset().top, jProductList );
    },
    setScrollTop: function ( intScrollTop ) {
        var jWindow = jQuery( window );
        if ( intScrollTop < jWindow.scrollTop() ) {
            intScrollTop -= jWindow.height() / 100 * e4.settings.scrollToAnchor.nudge;
            e4.scrollToAnchor.animate( intScrollTop, e4.header.hide );
        }
    },
    history: {
        params: null,
        init: function (jProductList) {
            if ( history.state !== null && history.state.params !== '' ) {
                e4.productlist.data.post( history.state.params, history.state.scrollTop, jProductList );
            }
            else {
                e4.productlist.data.post( jProductList.find( '.js-e-productlist-form' ).serialize(), 0, jProductList );
            }
            e4.productlist.history.popState();
        },
        pushState: function (jProductList) {
            var strTmplKey = jProductList.data("templatekey");
            var strUrlParam = e4.productlist.history.getParams(),
                stateObj    = {
                    params: e4.productlist.history.params,
                    scrollTop: jQuery( window ).scrollTop()
                };
            if ( jQuery( '#js-e-productlist-filters-' + strTmplKey ).length === 0 ) {
                e4.settings.ecom.filters.cleanUrl = true;
            }
            history.pushState( stateObj, null, location.pathname + ( e4.settings.ecom.filters.cleanUrl === false ? strUrlParam : '' ) );
        },
        getParams: function () {
            var paramArr = e4.productlist.history.params.split( '&' );
            for ( var i = paramArr.length - 1; i >= 0; i-- ) {
                if ( paramArr[ i ].indexOf( 'PageUrl' ) > -1 ) {
                    paramArr.splice( i, 1 );
                }
            }
            var urlParams = paramArr.join( '&' );
            if ( urlParams.indexOf( '?' ) === -1 ) {
                urlParams = '?' + urlParams;
            }
            return urlParams;
        },
        popState: function (jProductList) {
            jQuery( window ).on( 'popstate', function ( event ) {
                if ( event.originalEvent.state !== null ) {
                    e4.productlist.data.post( event.originalEvent.state.params, event.originalEvent.state.scrollTop, jProductList );
                }
            } );
        }
    },
    data: {
        post: function ( strUrlParam, intScrollTop, jProductList ) {
            jQuery.ajax( {
                type: 'GET',
                url: e4.settings.ecom.filters.url,
                cache: false,
                data: strUrlParam,
                beforeSend: function () {
                    jProductList.find( '.js-e-products-loading-overlay' ).addClass( 'is-loading' );
                }
            } )
            .done( function ( data ) {
                e4.productlist.history.params = strUrlParam;
                e4.productlist.data.handler( data, jProductList );
                e4.productlist.setScrollTop( intScrollTop );
                jProductList.removeClass( 'js-e-loading-wait' );
                if ( document.querySelector( '.js-e-loading-wait' ) === null ) {
                    e4.loading.done();
                }
            } )
            .fail( function ( error ) {
                console.error( error );
            } )
            .always( function () {
                jProductList.find( '.js-e-products-loading-overlay' ).removeClass( 'is-loading' );
            } );
        },
        handler: function ( data, jProductList ) {
            var selectedOptionsCount = 0;
            for ( var i = 0; i < data.facets.length; i++ ) {
                selectedOptionsCount += data.facets[ i ].selectedOptions.length;
            }
            if ( data.page.q !== null && data.page.q !== '' ) {
                selectedOptionsCount++;
            }
            if ( ( data.page.minPrice.clean !== null && data.page.minPrice.clean !== '' ) && ( data.page.maxPrice.clean !== null && data.page.maxPrice.clean !== '' ) ) {
                selectedOptionsCount++;
            }
            data.page.filtersAppliedCount = selectedOptionsCount;
            if ( selectedOptionsCount > 0 ) {
                data.page.hasNoInteraction = false;
            }
            if ( e4.util.hash.get( 'isModalFilter' ) === 'true' ) {
                data.page.isModalFilter = true;
            }
            e4.productlist.data.build( data, jProductList );
        },
        build: function ( data, jProductList ) {
            e4.productlist.history.pushState( jProductList );
            var strTmplKey = jProductList.data("templatekey");
            var jFilters          = jProductList.find( '#js-e-productlist-filters-' + strTmplKey ),
                jFiltersModal     = jProductList.find( '#js-e-productlist-filters-modal' ),
                jFiltersModalBody = jFiltersModal.find( '#js-e-productlist-filters-modal-body' ),
                jSort             = jProductList.find( '.js-e-productlist-sort' ),
                jPaging           = jProductList.find( '.js-e-productlist-paging' );
            
            if ( jFilters.length === 1 ) {
                var strFiltersHtml = "";
                strFiltersHtml = e4.handlebars.tmpl['productlistFilters-' + strTmplKey]( data );
                if ( jFilters.is( ':visible' ) === true ) {
                    jFilters.html( strFiltersHtml );
                }
                else {
                    jFiltersModalBody.html( strFiltersHtml );
                }
            }
            if ( jSort.length > 0 ) {
                jSort.html( e4.handlebars.tmpl.productlistSort( data ) );
            }
            if ( jPaging.length > 0 ) {
                jPaging.html( e4.handlebars.tmpl.productlistPaging( data ) );
            }
            e4.productlist.filters.refresh(jProductList);
            if ( data.page.isModalFilter === true ) { 
                jProductList.find( '.js-e-productlist-filters-modal' ).addClass( 'show' ).modal( 'show' );
            }

            jProductList.find( '.js-e-productlist-product-count' ).html( data.page.productCount );
            jProductList.find( '.js-e-productlist-filters-applied-count' ).html( data.page.filtersAppliedCount === 0 ? '' : data.page.filtersAppliedCount );
            jProductList.find( '#js-e-productlist-products' ).html( e4.handlebars.tmpl['productlistProducts-' + strTmplKey]( data ) );
            jProductList.trigger( e4.productlist.event.builded );
        }
    }
};

